import React from 'react';

export default function IndexSectionCallToAction15() {
    return (
        <React.Fragment>
            <>
                <section id={"waiting-list"} className="py-20 bg-green-100">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap items-center -m-4">
                            <div className="w-full lg:w-1/2 p-4">
                                <h1 className="font-heading text-4xl lg:text-5xl font-bold mb-6 max-w-xs lg:max-w-md">Are
                                    you not in New York?</h1>
                                <p className="text-gray-600 mb-6 max-w-md">Just a reminder that the App still only
                                    available in NY USA, if you are not please join our waiting list and we will notify
                                    you when your area is available.</p>
                                <div className="launchlist-widget h-96" data-key-id="ASI3pj" data-height="180px"></div>
                            </div>
                            <div className="w-full lg:w-1/2 p-4 relative">
                                <img className="absolute hidden lg:block top-0 left-0 mt-4 w-72 h-72 ml-5"
                                     src="cronos-assets/elements/dark-green-dark-warning-right.svg" alt/>
                                <div className="mx-auto flex flex-col w-72">
                                    <img className="ml-auto w-36 h-36" src="cronos-assets/elements/grey-square.svg"
                                         alt/>
                                    <div className="flex justify-end items-end">
                                        <img className="ml-auto w-72 h-72 object-cover"
                                             src="https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3wzMzIzMzB8MHwxfHNlYXJjaHwyfHxuZXclMjB5b3JrfGVufDB8fHx8MTc0ODk0MDAwNHww&ixlib=rb-4.1.0&q=85&w=1920"
                                             alt/>
                                    </div>
                                    <div className="flex justify-end">
                                        <img className="w-36 h-36" src="cronos-assets/elements/grey-square.svg" alt/>
                                        <img className="w-36 h-36 object-cover"
                                             src="https://images.unsplash.com/photo-1418075285575-c402f1f7340f?crop=entropy&cs=srgb&fm=jpg&ixid=M3wzMzIzMzB8MHwxfHNlYXJjaHwxNXx8bmV3JTIweW9ya3xlbnwwfHx8fDE3NDg5NDAwMDR8MA&ixlib=rb-4.1.0&q=85&w=1920"
                                             alt/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </>
        </React.Fragment>
    );
}

